import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions as addressActions } from '@/reducers/address-reducer';
import { actions as mainActions } from '@/bit/reducers/reducers.main-reducer';

function useAddress({
  formData,
  resetField,
  componentName,
  fieldToResetName,
  setInfo,
}) {
  const dispatch = useDispatch();
  const {
    municipio,
    x,
    mobile,
    cp: mainPostalCode,
  } = useSelector((state) => state.main);
  const [automaticAddress, setAutomaticAddress] = useState(true);
  const [verticalAddressSelected, setVerticalAddressSelected] = useState(null);
  const [horizontalAddressSelected, setHorizontalAddressSelected] =
    useState(null);

  const {
    horizontalAddresses,
    horizontalAddressesLoading,
    verticalAddresses,
    verticalAddressesLoading,
  } = useSelector((state) => state.address);

  const setHorizontalAddressSelectedCustom = (address) => {
    resetField(fieldToResetName, { keepTouched: false, keepDirty: false });
    const { full, idGeographicSite } = { ...address };
    setHorizontalAddressSelected({ ...address });
    if (address && typeof address === 'object' && !full) {
      dispatch(
        addressActions.initVerticalAddresses({
          address: '',
          idGeographicSite,
          componentName,
        })
      );
    }
    if (verticalAddressSelected) {
      resetField(fieldToResetName, {
        keepTouched: false,
        keepDirty: false,
        defaultValue: null,
      });
      setVerticalAddressSelected(null);
    }
  };
  const setVerticalAddressSelectedCustom = (address) => {
    setVerticalAddressSelected({ ...address });
  };

  const getHorizontalAddresses = ({ search }) => {
    const params = {
      address: search,
      componentName,
    };
    if (mainPostalCode) {
      params.orderPC = mainPostalCode;
    }
    dispatch(addressActions.initHorizontalAddresses(params));
  };
  const getVerticalAddresses = ({ search }) => {
    const { idGeographicSite } = { ...horizontalAddressSelected };
    dispatch(
      addressActions.initVerticalAddresses({
        address: search,
        idGeographicSite,
        componentName,
      })
    );
  };

  useEffect(() => {
    if (
      setInfo &&
      ((horizontalAddressSelected && horizontalAddressSelected.full) ||
        (verticalAddressSelected && verticalAddressSelected.full))
    ) {
      const fullAddressSelected =
        horizontalAddressSelected && horizontalAddressSelected.full
          ? horizontalAddressSelected
          : verticalAddressSelected;
      const { postalCode } = {
        ...horizontalAddressSelected,
      };
      const { zone, lineCoverage } = {
        ...fullAddressSelected,
      };
      const { ftthCoverage: coverage } = { ...lineCoverage };
      dispatch(addressActions.setZone({ zone }));
      dispatch(addressActions.setCoverage({ coverage }));
      dispatch(
        mainActions.setCpParams({
          municipio,
          x,
          mobile,
          cp: postalCode,
          zone,
          persist: true,
        })
      );
      dispatch(setInfo({ formData }));
    }
  }, [verticalAddressSelected, horizontalAddressSelected]);

  return {
    getHorizontalAddresses,
    setHorizontalAddressSelected: setHorizontalAddressSelectedCustom,
    horizontalAddresses: horizontalAddresses
      ? horizontalAddresses[componentName] || null
      : null,
    horizontalAddressesLoading: horizontalAddressesLoading
      ? horizontalAddressesLoading[componentName] || null
      : null,
    horizontalAddressSelected,
    getVerticalAddresses,
    setVerticalAddressSelected: setVerticalAddressSelectedCustom,
    verticalAddresses: verticalAddresses
      ? verticalAddresses[componentName] || null
      : null,
    verticalAddressesLoading: verticalAddressesLoading
      ? verticalAddressesLoading[componentName] || null
      : null,
    verticalAddressSelected,
    setAutomaticAddress,
    automaticAddress,
  };
}

export default useAddress;
